import { jwtDecode } from 'jwt-decode';

let initialValue = {};

export function getUser() {
  const token = localStorage.getItem("token");
  if (token) {
    try {
      const decoded = jwtDecode(token);
      return { ...initialValue, ...decoded };
    } catch (e) {
      console.error("Failed to decode token", e);
      return initialValue;
    }
  }
  return initialValue;
}

export function setUser(params) {
  initialValue = params;
}

export async function getUserAccessToken() {
  return localStorage.getItem("token");
}

export async function getAccessHeader() {
  const token = localStorage.getItem("token");
  return {
    headers: {
      Authorization: token ? `Bearer ${token}` : "",
    },
  };
}

export function rsaEncription(value) {
  // Mock encryption or implement if needed
  return value;
}
